module.exports = __webpack_public_path__ + "img/editorial.12313c40.svg";